<template>
  <div class="main-panel">
    <div class="content-wrapper dashboard-shell">
      <div class="cardplay procesos-shell">
        <div class="card-body procesos-card-body">
          <div class="row dashboard-header g-3 align-items-center mb-4">
            <div class="col-12 col-lg-8">
              <h2 class="dashboard-title mb-1">Procesos Legales</h2>
              <p class="procesos-subtitle mb-0">
                Visualiza y filtra el estado actual de cada proceso de forma clara y ordenada.
              </p>
            </div>

            <div class="col-12 col-lg-4 d-flex justify-content-lg-end align-items-start">
              <span class="procesos-badge" :class="animClass" :style="{ color: colorPorEstatus }">
                {{ tituloPorEstatus }}
              </span>
            </div>
          </div>

          <div class="row mb-3 justify-content-start">
            <div class="col-12 col-md-6 col-lg-4">
              <label for="estadoProceso" class="form-label procesos-label">Mostrar:</label>
              <select v-model="filtradoEstatus" id="estadoProceso" class="form-select procesos-select">
                <option value="Todos">Todos</option>
                <option v-for="opt in estatusOptions" :key="opt" :value="opt">{{ opt }}</option>
              </select>
            </div>
          </div>

          <TablaProcesos :key="filtradoEstatus" :estatus="filtradoEstatus" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TablaProcesos from './TablaProcesos.vue';

export default {
  name: 'MostrarProcesos',
  components: { TablaProcesos },
  data() {
    return {
      filtradoEstatus: 'Todos',
      estatusOptions: [
        'NOTIFICADA',
        'POR NOTIFICAR',
        'PRESENTADA',
        'RECHAZADA',
        'RETORNADA',
        'SUBSANADA',
        'TRABAJO',
        'ADMITIDA',
      ],
    };
  },
  computed: {
    tituloPorEstatus() {
      return this.filtradoEstatus === 'Todos' ? 'Todos los estados' : this.filtradoEstatus;
    },
    colorPorEstatus() {
      const map = {
        NOTIFICADA: '#38bdf8',
        'POR NOTIFICAR': '#fbbf24',
        PRESENTADA: '#34d399',
        RECHAZADA: '#f87171',
        RETORNADA: '#c4b5fd',
        SUBSANADA: '#67e8f9',
        TRABAJO: '#d1d5db',
        ADMITIDA: '#22d3ee',
        Todos: '#e5e7eb',
      };
      return map[this.filtradoEstatus] || '#e5e7eb';
    },
    animClass() {
      return ['bounceInLeft', 'bounceInRight'][Number(new Date()) % 2];
    },
  },
};
</script>

<style scoped>
.dashboard-shell {
  background: linear-gradient(165deg, #f5f7fb 0%, #eef1f7 45%, #f8fafc 100%);
  min-height: 100vh;
}

.cardplay {
  border-radius: 24px;
  border: 1px solid #e5e7eb;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.procesos-card-body {
  padding: 0;
}

.dashboard-header {
  background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
  border-radius: 18px;
  color: #fff;
  padding: 14px 16px;
}

.dashboard-title {
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.procesos-subtitle {
  color: #e5e7eb;
  font-size: 0.95rem;
}

.procesos-badge {
  display: inline-block;
  border: 1px solid #e5e7eb66;
  border-radius: 999px;
  padding: 0.3rem 0.75rem;
  background: rgba(255, 255, 255, 0.08);
  font-size: 0.85rem;
  font-weight: 600;
}

.procesos-label {
  font-weight: 600;
  color: #334155;
}

.procesos-select {
  border-radius: 12px;
  border: 1px solid #d1d5db;
  min-height: 44px;
}

.bounceInLeft {
  animation: bounceInLeft 1s both;
}

@keyframes bounceInLeft {
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }

  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }

  75% {
    transform: translate3d(-10px, 0, 0);
  }

  90% {
    transform: translate3d(5px, 0, 0);
  }

  100% {
    transform: none;
  }
}

.bounceInRight {
  animation: bounceInRight 1s both;
}

@keyframes bounceInRight {
  0% {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }

  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }

  75% {
    transform: translate3d(10px, 0, 0);
  }

  90% {
    transform: translate3d(-5px, 0, 0);
  }

  100% {
    transform: none;
  }
}
</style>
